const openClass = 'ac--open'

// Provides a class to handle the autocomplete functionality.
class AutoComplete {
  constructor (elem) {
    this.elem = elem
    this.itemList = elem.querySelector('ul')

    this.elem.addEventListener('click', e => e.stopPropagation())
  }

  removeContents () {
    this.itemList.innerHTML = ''
  }

  returnItemDetails (item, needle) {
    return `<li class="ac__item">
      <a href="${item.url}" class="ac__link">
        ${this.markSearch(item.title, needle)}
      </a>
    </li>`
  }

  markSearch (inputString, searchString) {
    if (searchString) {
      // Create a regular expression using the searchString and the 'g' flag for global matching
      const regex = new RegExp(searchString, 'gi')
      // Replace the searchString with the marked version using the replace() function
      const markedString = inputString.replace(regex, '<span class="ac__match">$&</span>')

      return markedString
    } else {
      return inputString
    }
  }

  open (items, needle) {
    this.elem.classList.add(openClass)
    if (items.length > 0) {
      this.itemList.innerHTML = items.map(x => this.returnItemDetails(x, needle)).join('')
    } else {
      this.close(true)
    }
  }

  close (removeContents = true) {
    this.elem.classList.remove(openClass)

    if (removeContents) {
      this.removeContents()
    }
  }
}

export {
  AutoComplete
}
